import { RadarMonitorPanel, type RadarMonitorProps } from './RadarMonitorPanel';
import { RadarNextActionCard } from './RadarNextActionCard';
import { useOutreachFlow } from './RadarOutreachFlow';
import { radarApi } from './radarApi';
import { useRadarLocale } from '@/i18n/RadarLocaleContext';

/** Presentation adapter. Advice content/generation remains owned by PR #237. */
export function RadarMonitorWorkspace({token,workspaceId,...props}:Omit<RadarMonitorProps,'loadEvents'|'renderCompanyAdvice'|'contextKey'|'workspaceId'> & {token:string;workspaceId:string}) {
  const flow=useOutreachFlow();
  const {t}=useRadarLocale();
  const contextKey=JSON.stringify([workspaceId,props.plan?.id,props.plan?.revision,props.plan?.brief_revision,
    props.watches.map(w=>[w.id,w.status,w.check_state,w.contact_state,w.last_checked_at,w.signals?.map(s=>[s.id,s.feedback])])]);
  return <RadarMonitorPanel {...props} workspaceId={workspaceId} contextKey={contextKey}
    loadEvents={query=>radarApi.monitoringEvents(token,workspaceId,query)}
    renderCompanyAdvice={(watch,feedbackRevision)=>{
      const key=watch.company?.company_key;
      const existing=key && flow && (flow.batches.some(b=>b.items.some(i=>i.company_key===key))
        || flow.eligibility?.some(item=>item.company_key===key && !!item.reason));
      return <>{existing && <p><button type="button" className="radar-monitor-link" onClick={()=>flow.focus(key)}>{t('View contact history in Act')}</button></p>}
        <RadarNextActionCard key={watch.company_id} companyId={watch.company_id} contextKey={`${contextKey}/${feedbackRevision}`}
        loadAdvice={()=>radarApi.monitoringAdvice(token,workspaceId,watch.company_id)}
        onOpenContacts={existing ? ()=>flow.focus(key) : undefined}/></>;
    }}/>
}
